export default {
  methods: {
    showModal() {
      // 使用 Bootstrap 的 JavaScript API 显示模态对话框
      $(this.$refs.myModal).modal('show');
    }
  }
};